// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"c567510b","89":"9ecb2b0d","94":"c9278e36","264":"d425451b","355":"62f98d84","383":"5543019a","422":"0abd584f","577":"986bba2c","613":"ef97b6d3","665":"a3816e77","819":"1460a514","930":"b5a94b82","984":"81afae6b"}[chunkId] + ".chunk.js";
};